// ArChat Language Extension
// Created: 13-03-2026 00:00:00
// Author: SIVOL® - Aldo Frias - Argentina

import { plansTranslationsEn } from './plansTranslations.en.js';

export const plansTranslationsTr = {
  ...plansTranslationsEn,
  'plans.compare.title': 'Planını seç',
  'plans.compare.cta.foundation': 'Founder ol',
  'plans.compare.cta.pro': 'PRO planına geç',
  'plans.compare.active': 'Mevcut plan',
  'plans.limit.reached': 'Limit aşıldı — Plan yükselt',
  'plans.compare.pro.adjustment_notice': 'Fiyat, hizmet koşullarına göre ayarlanabilir.',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.foundation.badge': '150 sinirli kontenjan',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Mesaj limiti doldu',
  'plans.limit.message.messages': 'Mesaj limitine ulastiniz. FOUNDATION veya PRO planina gecin.',
  'plans.limit.title.storage': 'Depolama limiti doldu',
  'plans.limit.message.storage': 'Depolama limitine ulastiniz. Daha fazla dosya yuklemek icin plani yukselin.',
  'plans.limit.title.invitations': 'Davet limiti doldu',
  'plans.limit.message.invitations': 'Davet limitine ulastiniz. Daha fazla davet icin plani yukselin.',
  'plans.founder.remaining': '{count} Founder koltugu kaldi',
  'plans.founder.remaining_last': 'Son {count} Founder koltugu',
  'plans.founder.remaining_limited': 'Sinirli: {count} koltuk kaldi',
  'plans.founder.remaining_very_low': 'Sadece {count} Founder koltugu kaldi',
  'plans.founder.soldout': 'Founder tukendi',
  'plans.compare.institucional.title': 'Baslik',
  'plans.compare.yourPlan': 'Planiniz',
  'plans.modal.title': 'Plani yuksel',
  'plans.modal.comparison_title': 'Plan karşılaştırması',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Ucretsiz Plan',
  'plans.free.price': '$0 / ay',
  'plans.free.features.contacts': 'Kullanıcı başına en fazla 2 kişi',
  'plans.free.features.conversations': 'Hesap başına en fazla 2 aktif sohbet',
  'plans.free.features.no_export': 'Hesap başına ayda 30.000 karakter; günde 34 ve ayda 1.000 mesaj; dışa aktarma yok',
  'plans.free.features.no_advanced': 'Dosya veya depolama yok; 30 günlük geçmiş; kullanıcı başına 1 cihaz',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Founder Plani',
  'plans.foundation.features.contacts': 'PRO ile aynı premium sözleşme (kullanıcı başına en fazla 100 kişi)',
  'plans.foundation.features.conversations': 'Sınırsız sohbet (tenant); PRO ile aynı limitler',
  'plans.foundation.features.badge': 'Founder programı (150 numaralı kontenjan)',
  'plans.foundation.features.support': 'Founder kotası varken ayda USD 15',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Pro Plani',
  'plans.pro.features.contacts': 'Kullanıcı başına en fazla 100 kişi',
  'plans.pro.features.conversations': 'Sınırsız sohbet (tenant); günde 1.667, ayda 50 bin mesaj',
  'plans.pro.features.export': 'En fazla 50 MB (tenant); dışa aktarma, çeviri ve dosyalar plana göre',
  'plans.pro.features.notifications': 'Kullanıcı başına en fazla 3 cihaz; sınırsız davet (tenant)',
  'plans.actions.free': 'Mevcut plan',
  'plans.actions.foundation': 'Founder ol',
  'plans.actions.pro': 'PRO planına geç',
  'plans.badges.recommended': 'ONERILEN',
  'plans.badges.limited': 'SINIRLI',
  'plans.badges.foundation': 'Founder',
  'plans.modal.free.line1': 'Hesap başına ayda 30.000 karakter.',
  'plans.modal.free.line2': 'Kullanıcı başına en fazla 2 kişi.',
  'plans.modal.free.line3': 'Hesap başına en fazla 2 aktif konuşma.',
  'plans.modal.free.line4': 'Dosya eki veya depolama alanı yok.',
  'plans.modal.free.line5': 'Veri dışa aktarımı yok.',
  'plans.modal.free.line6': 'Mesaj geçmişi en fazla 30 gün.',
  'plans.modal.free.line7': 'Kullanıcı başına yalnızca 1 cihaz.',
  'plans.modal.premium.line1': 'Hesap başına ayda 300.000 karakter.',
  'plans.modal.premium.line2': 'Kullanıcı başına en fazla 100 kişi.',
  'plans.modal.premium.line3': 'Sınırsız konuşma ve sohbet (tenant).',
  'plans.modal.premium.line4': 'En fazla 50 MB depolama (tenant).',
  'plans.modal.premium.line5': 'Kullanıcı başına en fazla 3 cihaz.',
  'plans.modal.premium.line6': 'Sınırsız davet (tenant).',
  'plans.modal.premium.line7': 'Plan limitleri dahilinde dışa aktarma, otomatik çeviri ve dosyaları içerir.',
  'plans.modal.premium_block_heading': 'Motor kullanım limitleri (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Founder programı',
  'plans.modal.foundation.categories_title': 'Founder kategorileri ({slots} yer)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Pozisyon 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'Projeyi ilk destekleyenler. En yüksek tarihsel öncelik.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Pozisyon 26–75',
  'plans.modal.foundation.cat_early_desc': 'Özel tanınma ile erken destek.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Pozisyon 76–150',
  'plans.modal.foundation.cat_std_desc': '150 yer içinde Founder yerı.',
  'plans.modal.foundation.advantages_title': 'Founder avantajları',
  'plans.modal.foundation.adv1': 'Sınırlı Founder havuzuna erişim ({slots} numaralı yer).',
  'plans.modal.foundation.adv2': 'ArChat kurucu kullanıcı olarak tanınma.',
  'plans.modal.foundation.adv3': 'Ürün deneyiminde Founder rozeti ve varlığı.',
  'plans.modal.foundation.adv4': 'Konumunuza göre (1–150) tarihsel öncelik ve statü.',
  'plans.modal.foundation.adv5': 'Geçerli politika sürdükçe Founder erişiminize bağlı sürekli fayda.',
  'plans.modal.pro.tagline': 'Standart premium — Founder bileşeni yok',
  'plans.payments_disabled.title': 'Abonelikler',
  'plans.payments_disabled.message': 'Abonelikler kademeli olarak etkinleştiriliyor. Mevcut planları ve avantajlarını görüntüleyebilirsiniz.',
  'plans.payments_disabled.confirm': 'Tamam',
};